export const trimString = str => (
  str.replace(/^\s+|\s+$/g, '')
)

export const pluralize = (str, count, suffix = 's') => (count > 1 ? str + suffix : str)
